'use client';

import Image from 'next/image';
import Link from 'next/link';

import type { BlogPostCardComponentProps, CategoryDisplay } from './blogTypes';

export default function BlogPostCard({
  post,
  featured = false,
}: BlogPostCardComponentProps) {
  // Xử lý danh mục bài viết từ Ghost API
  const categories: CategoryDisplay[] = post.tags?.map((tag) => ({
    name: tag.name,
    slug: tag.slug,
  })) || [{ name: 'Uncategorized', slug: 'uncategorized' }];

  if (featured) {
    return (
      <div className="group overflow-hidden rounded-xl border bg-white shadow-sm transition-all duration-300 hover:border-primary-200">
        <Link href={`/blogs/${post.slug}/`} className="">
          <div className="grid grid-cols-1 gap-0 md:grid-cols-12">
            <div className="relative h-64 w-full md:col-span-7 md:h-auto">
              <Image
                src={post.feature_image || '/placeholder.jpg'}
                alt={post.title}
                fill
                className=" object-cover object-center brightness-[0.85]"
              />
              <div className="absolute left-4 top-4 z-10 flex flex-wrap gap-2 transition-transform duration-300 group-hover:scale-105">
                {categories.map((category, index) => (
                  <p
                    key={index}
                    className="rounded-full bg-primary-500 px-3 py-1 text-sm text-white"
                  >
                    {category.name}
                  </p>
                ))}
              </div>
            </div>
            <div className="flex flex-col justify-center p-6 md:col-span-5 md:p-8">
              <div className="mb-3 flex items-center space-x-2 text-sm text-gray-500">
                <span>
                  {new Date(post.updated_at).toLocaleDateString()} •{' '}
                  {post.authors?.[0]?.name || 'Unknown Author'}
                </span>
              </div>
              <h2 className="mb-4 text-left text-2xl font-bold text-gray-900 md:text-3xl">
                <div className="transition-colors group-hover:text-primary-600">
                  {post.title}
                </div>
              </h2>
              <p className="mb-6 text-left text-gray-600">{post.excerpt}</p>
            </div>
          </div>
        </Link>
      </div>
    );
  }

  return (
    <Link
      key={post.id}
      href={`/blogs/${post.slug}/`}
      className="group !text-left transition-all"
    >
      <div className="flex h-full flex-col bg-white">
        <div className="relative h-48 overflow-hidden rounded-lg">
          <Image
            src={post.feature_image || '/default-image.jpg'}
            alt={post.title}
            fill
            style={{ objectFit: 'cover' }}
            className="transition-transform duration-300 group-hover:scale-110"
          />
        </div>
        <div className="flex grow flex-col py-4">
          <h3 className="text-left text-base font-medium transition-colors group-hover:text-primary-600">
            {post.title}
          </h3>
          <div className="text-sm text-gray-600">
            <span>{post.updated_at}</span> •{' '}
            <span>{post.tags?.[0]?.name || 'Uncategorized'}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
